import React from 'react';

const NotFound = () => {
    return (
        <div> 
            This is Not Found Page
        </div>
    );
}
export default NotFound;